const colors = {
  white: "#ffffff",
  light: "#FAFAFC",
  green: "#BADC58",
  blue: "#2D3561",
  darkBlue: "#1d164d",
  variantGray: {
    100: "#9E9BAF",
    200: "#b4b4b4",
    300: "#707070",
  },
};

export type ThemeType = typeof colors;
export default colors;
